import React from 'react';
import { Link } from 'react-scroll';
import { navLinks } from './data/navigation';
import useActiveSection from '../hooks/useActiveSection';
import usePrefersReducedMotion from '../hooks/usePrefersReducedMotion';

const ids = navLinks.map(({ to }) => to);

// Left-hand index of the page. Desktop only; the navbar covers small screens.
const SectionRail = () => {
  const active = useActiveSection(ids);
  const reduced = usePrefersReducedMotion();

  return (
    <nav className="rail" aria-label="Section index">
      <ol className="rail-list">
        {navLinks.map(({ to, label }) => (
          <li key={to} className={active === to ? 'rail-item is-active' : 'rail-item'}>
            <Link
              to={to}
              href={`#${to}`}
              smooth={!reduced}
              offset={-64}
              duration={120}
              className="rail-link"
              aria-current={active === to ? 'location' : undefined}
            >
              {label}
            </Link>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default SectionRail;
